var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'filter-tag-container',
    {
      'filter-tag-container--tooltip': _vm.tooltipText
    }
  ]},[(_vm.tooltipText)?_c('InfoIcon',{directives:[{name:"tippy",rawName:"v-tippy",value:({
      placement: 'bottom',
      arrow: true,
      arrowType: 'round',
      offset: '0, 0'
    }),expression:"{\n      placement: 'bottom',\n      arrow: true,\n      arrowType: 'round',\n      offset: '0, 0'\n    }"}],staticClass:"filter-tag__tooltip",attrs:{"content":_vm.tooltipText,"height":16,"width":16}}):_vm._e(),_c(_vm.as,{tag:"component",class:[
      ("filter-tag filter-tag--size-" + _vm.size + " filter-tag--theme-" + _vm.theme),
      {
        'filter-tag--active': _vm.isActive,
        'filter-tag--view-only': _vm.viewOnly,
        'filter-tag--unmargin': _vm.unmargin
      }
    ],style:(_vm.themeStyle),on:{"click":function($event){!_vm.viewOnly ? _vm.$emit('click') : null}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),(!_vm.viewOnly)?_c('div',{staticClass:"filter-tag__close"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }